module.exports = __webpack_public_path__ + "static/media/QS.3e470051.svg";